import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CsmUserProfile = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "csm-user-profile" */ './csm-variants')),
});
